/** 是否 IE 浏览器 */
export const isIE = 'ActiveXObject' in window

/** 从配置获取尺寸 */
export const getSizeCfg = (size: string) => {
  const [width, height] = size.split(',').map(x => +x)
  return { width, height }
}
